// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selection-card{cursor:pointer;border:1px solid #f58319;border-radius:5px;margin:10px 0}.selection-card.selected{border:2px solid #f58319;background-color:#e0e0e0}.selection-card:hover{box-shadow:0 0 10px #f58319}.selection-card .headerline,.selection-card .title{font-size:1.2em;font-weight:700;color:#f58319}.selection-card .headerline{border-bottom:1px solid #f58319;margin-bottom:10px;padding-bottom:10px}", ""]);
// Exports
module.exports = exports;
